import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import CategoryTile from '../components/Collections/CategoryTile';
import { CATEGORIES, categoryLabels, heroForCategory } from '../data/products';

const Section = styled.section`
  padding: 8rem 0 6rem;
  background-color: ${({ theme }) => theme.colors.background};
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
`;

const Heading = styled.h1`
  font-size: 3rem;
  text-align: center;
  margin-bottom: 0.5rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 2.25rem;
  }
`;

const Lede = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.colors.lightText};
  max-width: 540px;
  margin: 0 auto 4rem;
`;

const PlaceholderTile = styled(Link)`
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.lightText};
  font-family: ${({ theme }) => theme.fonts.accent};
  font-size: 1.5rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  transition: color ${({ theme }) => theme.transitions.short};

  &:hover {
    color: ${({ theme }) => theme.colors.text};
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${({ theme }) => theme.spacing.lg};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

const Collections: React.FC = () => (
  <Section>
    <Container>
      <Heading>Collections</Heading>
      <Lede>Each piece is handmade, considered, and meant to mark a moment.</Lede>
      <Grid>
        {CATEGORIES.map((category) => {
          const imageId = heroForCategory(category);
          return imageId ? (
            <CategoryTile key={category} category={category} imageId={imageId} />
          ) : (
            <PlaceholderTile key={category} to={`/collections/${category}`}>
              {categoryLabels[category]}
            </PlaceholderTile>
          );
        })}
      </Grid>
    </Container>
  </Section>
);

export default Collections;
